import API from "@/utils/Api";
import { get } from "@/context/context";
import {AxiosResponse} from "axios";
import {FileRepository} from "@/repositories/FileRepository";
import {FileImageResponse} from "@/models/File/FileImageResponse";
import {FileVideoResponse} from "@/models/File/FileVideoResponse";
import {FileAudioResponse} from "@/models/File/FileAudioResponse";
import {RequestConfig} from "@/models/RequestConfig";
import {FileRequest} from "@/models/File/FileRequest";
import {Servers} from "@/serverConfig";

export class FileApi implements FileRepository {

    private api: API = get('api');

    public async uploadImage(request: FileRequest, config?: RequestConfig): Promise<FileImageResponse> {
        let payload = new FormData();
        payload.append('file', request.file);
        const response: AxiosResponse<FileImageResponse> =
            await this.api.post('/uploader/wix/amazon-image-save-resize', payload, config);
        const { data } = response;
        return data || null;
    }

    public async uploadAvatar(request: FileRequest, config?: RequestConfig): Promise<FileImageResponse> {
        let payload = new FormData();
        payload.append('file', request.file);
        const response: AxiosResponse<FileImageResponse> =
            await this.api.post('/uploader/wix/amazon-photo-save', payload, config);
        const { data } = response;
        return data || null;
    }

    public async uploadVideo(request: FileRequest, config?: RequestConfig): Promise<FileVideoResponse> {
        let payload = new FormData();
        payload.append('file', request.file);
        const response: AxiosResponse<FileVideoResponse> =
            await this.api.post('/uploader/wix/amazon-video-save-resize', payload, config);
        const { data } = response;
        return data || null;
    }

    public async uploadAudio(request: FileRequest, config?: RequestConfig): Promise<FileAudioResponse> {
        let payload = new FormData();
        payload.append('file', request.file);
        const response: AxiosResponse<FileAudioResponse> =
            await this.api.post('/uploader/wix/amazon-audio-save', payload, config);
        const { data } = response;
        return data || null;
    }

    public async uploadMultiAudio(request: any, config?: RequestConfig): Promise<FileAudioResponse> {
        this.api.changeServer(Servers.TEST);
        let payload = new FormData();
        for (const i in request) {
            payload.append('files', request[i]);
        }
        const response: AxiosResponse<FileAudioResponse> =
            await this.api.post('/uploader/wix/amazon-audio-save-multiple', payload, config);
        const { data } = response;
        return data || null;
    }
}
